<script setup lang="ts">
import type { ApiClientConfig } from 'use-api-vue';
import { useApiProvider } from 'use-api-vue';

import LocaleProvider from './global/LocaleProvider.vue';

import { useConfigProvider } from '@/providers/config/useConfig';
import { useRightsProvider } from '@/providers/useRights';
import { getError } from '@/util/api/ajax/ApiResponse';
import { getConfig } from '~/config/constants';

const constants = getConfig(useRuntimeConfig());

const apiConfig: ApiClientConfig = {
  requestConfig: {
    withCredentials: true,
    baseURL: `${constants.domains.api}/v2`,
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getError: (error) => getError(error as any),
};
useApiProvider(apiConfig);
useConfigProvider();
useRightsProvider();
</script>
<template>
  <LocaleProvider>
    <UApp :toaster="{ position: 'top-center' }">
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </UApp>
  </LocaleProvider>
</template>
